<template>
    <div :class="{'lnk-form-cell': true, 'has-mutil-cols': hasMultiCols}" :style="style"><slot/></div>
</template>

<script>
    export default {
        name: "lnk-form-cell",
		inject: {
			myCol: {default: ''},
		},
		computed: {
        	hasMultiCols(){
				if(!this.myCol) return false;
				const {cellCols} = this.myCol;
				if(cellCols < 2) return true;
				return true;
			},
        	style(){
        		if(!this.hasMultiCols) return {};
        		const {option, cellCols} = this.myCol;
				let labelWidth = (option.elFormProps || {}).labelWidth || '100px';
				labelWidth = labelWidth.replace('px', '') - 0;
				return `width: calc(${(cellCols * 5 - 1) / 5 / cellCols * 100}% + ${(cellCols - 1)  * labelWidth / 5 / cellCols}px)`;
			}
		}
    }
</script>

<style scoped>

</style>
